import { a as p } from "./lib-e3113bc3.mjs";
var s = Object.defineProperty, a = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, _ = Object.prototype.propertyIsEnumerable, o = (t, r, e) => r in t ? s(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e, n = (t, r) => {
  for (var e in r || (r = {}))
    i.call(r, e) && o(t, e, r[e]);
  if (a)
    for (var e of a(r))
      _.call(r, e) && o(t, e, r[e]);
  return t;
}, f = p({
  prop: "size",
  css: ["width", "height"]
});
export {
  n as _,
  f as s
};
